// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__n9f6l","image":"Header_image__2FgmY","name":"Header_name__13LQm","info":"Header_info__1DfRD","infoRow":"Header_infoRow__1_buG"};